import { type PropsWithChildren, type ReactNode } from 'react';

import styles from './PriceLayout.css';

export function PriceLayout({ children }: PropsWithChildren): ReactNode {
  return <div className={styles['price']}>{children}</div>;
}
